import { defineAction } from '~/prix'
import { z } from 'zod'
import benefitProgramUpdateAction from './benefitProgramUpdate.action.json' with { type: 'json' }
import { benefitProgramObject } from '../benefitProgramObject'

const benefitProgramUpdateDefinition = defineAction({
  ...benefitProgramUpdateAction,

  input: benefitProgramObject
    .pick({
      id: true,
      name: true,
      unitValue: true,
      discountPercent: true,
      calculationRules: true,
      active: true,
    })
    .partial()
    .required({ id: true }),
  output: z.object({}),
})

export default benefitProgramUpdateDefinition
